<template>
  <div class="sidebarleft">
    <div class="optlist">
      <SmallOption
        v-for="option in options" 
        @click="setOption(option)"
        class="sbopt"
        :active="option.name == selectedOption?.name"
        :image="option.image"
        :imageblack="option.imageblack"
        :key="option.id"  />
    </div>
  </div>
</template>

<script>
import SmallOption from '@/components/smallOption.vue';

export default {
  name: 'NavDrawer',
  props: ["options","selectedOption"],
  emit:["optionChosen"],
  components:{
    SmallOption
  },
  methods: {
    setOption(option){
      this.$emit('optionChosen',option);
    }
  }
}
</script>

<style>
.sbopt img{
  width: 30px;
}
.sbopt p {
  font-size: 15px;
} 

.sbopt.active, .sbopt:hover{
  color:#2650e7;
}

@media only screen and (max-width:1024px) and (min-width: 768px) {
  .sbopt img{
    width: 38px;
    padding-bottom: 8px;
    padding-top: 8px;
  }
}
</style>

<style scoped>
.sidebarleft{
  position: relative;
  /*height: calc(100vh - 86px);*/
  background-color: #f6f6f6;
  padding-left: 10px;
  padding-top: 20px;
  z-index: 100;
  min-width: 59px;
}
.optlist{
  font-family: "Montserrat Light";
  margin-bottom: 30px;
}
.sbopt{
  margin-bottom: 10px;
  padding: 5px 10px;
  display: flex;
  justify-content: center;
}

.sbopt.active{
  color: #2650e7;
}

.sbopt:hover{
  cursor: pointer;
}
</style>